import {check_logged_in} from '$lib/utils.js';
import Cookies from 'js-cookie';

// This top-level load function is used to retrieve logged in status for all
// pages (used in src/lib/header/Header-app.svelte)
export async function load({data}) {
    return {
        logged_in: check_logged_in(data)
    }
}
